<form
  class="container-fluid p-4"
  [formGroup]="CanadianWorkersCompensationFormGroup"
>
  <div class="row row-padding justify-content-center">
    <div class="col-auto">
      <label class="fs-30"
        >Canadian Workers Compensation -
        {{ CanadianWorkersCompensationType }}</label
      >
    </div>
  </div>

  <div class="row row-padding">
    <div class="col-4">
      <button class="btn btn-primary" (click)="openCAWCLookup()">
        {{ CanadianWorkersCompensationType }} LOOKUP
      </button>
    </div>
    @if (CanadianWorkersCompensationType === 'WSIB') {
      <div class="col-4">
        <button class="btn btn-primary" (click)="runCAWCLookup()">
          Run lookup
        </button>
      </div>
    }
    @if (
      CanadianWorkersCompensationType === 'WSIB' && WSIBCertificateImageFile
    ) {
      <div class="col-4">
        <button class="btn btn-primary" (click)="displayWSIBCertificateImage()">
          View wsib image
        </button>
      </div>
    }
  </div>

  <div class="row row-padding">
    <div class="col">
      <div class="form-check">
        <label class="form-check-label my-0">Is Exempt?</label>
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="CAWCExempt"
        />
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <div class="row">
        <div class="col">
          <label
            >{{ CanadianWorkersCompensationType }} Account #<span
              class="required-field-asterisk"
              >*</span
            ></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            class="form-control"
            type="text"
            formControlName="CAWCNumber"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <label>Certificate #</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            class="form-control"
            type="text"
            formControlName="CAWCcertNumber"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <div class="row">
        <div class="col">
          <label>Status<span class="required-field-asterisk">*</span></label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="CAWCStatus">
            @for (StatusObject of Statuses; track StatusObject) {
              <option [ngValue]="StatusObject.value">
                {{ StatusObject.label }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          <label
            >Certificate Expiration Date<span class="required-field-asterisk"
              >*</span
            ></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              placeholder="MM/DD/YYYY"
              formControlName="CAWCDate"
              navigation="select"
              ngbDatepicker
              container="body"
              #expirationDatePicker="ngbDatepicker"
              appNgbDateInputMask
            />
            <button
              class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
              (click)="expirationDatePicker.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-secondary" (click)="close()">Cancel</button>
    </div>
    <div class="col">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</form>
